import { TablePaginationConfig } from "antd/lib/table";
import { ApiResponse } from "../../services/API";
import reduce from "lodash/reduce";
import last from "lodash/last";
import values from "lodash/values";
import { Moment, FormatDate, FormatSendDate } from "./date_helpers";

export const DEAFAULT_PAGINATION_LIMIT = 5;

export interface iPagination extends TablePaginationConfig {
  current?: number; // current page number
  pageSize?: number; // number of data items per page
  total?: number; // total number of data items
  pageCount?: number;
  sorter?: string;

  pageSizeOptions?: string[];
  onShowSizeChange?: (...args: any[]) => any;
  onChange?: (...args: any[]) => any;
  showSizeChanger?: boolean;

  sort?: any;
  sort_direction?: "ASC" | "DESC";
}

export interface iPaginationParams {
  page?: number;
  pageSize?: number;
  // order: string
  sort?: string; // sort=name e sort=-name
}

export const getPaginationFromResponse = (responseData: ApiResponse) => {
  const {
    pageCount = 1,
    total = 1,
    page: current = 1,
    pageSize = DEAFAULT_PAGINATION_LIMIT,
  } = responseData?.pagination || {};

  /*
  current: number, //current page number
  pageSize:number, //number of data items per page
  total: number, //total number of data items
  pageCount?: number,
    */
  const pagination: iPagination = {
    current: parseInt(`${current}`, 10),
    pageCount: parseInt(`${pageCount}`, 10),
    pageSize: parseInt(`${pageSize}`, 10),
    total: parseInt(`${total}`, 10),
    hideOnSinglePage: true,
  };
  return pagination;
};

export const formatPaginationForService = (pagination: iPagination) => {
  const {
    current: page = 1,
    pageSize = DEAFAULT_PAGINATION_LIMIT,
    sort,
    sort_direction,
  } = pagination;

  /*
  current: number, //current page number
  pageSize:number, //number of data items per page
  total: number, //total number of data items
  pageCount?: number,
    */
  //debugger;
  const sortKey: any = sort?.length ? last(sort) : "";
  const paginationParams: iPaginationParams = {
    page: parseInt(`${page}`, 10),
    pageSize: parseInt(`${pageSize}`, 10),
    sort: sort_direction === "ASC" ? `-${sortKey}` : sortKey,
  };
  return paginationParams;
};

export const formatFiltersForService = (filters: {} = {}) => {
  let formattedFilters = reduce(
    filters,
    (prev, value: any, fieldName) => {
      const key = fieldName.split(".").pop() || 0;
      let val: any = value;

      if (Array.isArray(value)) {
        if (value.length === 1) val = value?.[0];
        else val = value.toString();
      }
      if (Moment.isMoment(val)) {
        // val = FormatSendDate(val,'YYYY-MM-DD')
        val = FormatSendDate(val);
      }

      if (val !== undefined) {
        prev[key] = val;
      }
      return prev;
    },
    {}
  );

  return formattedFilters;
};

export const objectIsAllUndefined = (obj: any) => {
  const isAllUndefined = !values(obj).some((x) => x !== undefined); // true
  return isAllUndefined;
};

export const sortId = (paginationParams: any) => {
  if (paginationParams.sort === "" || paginationParams.sort === undefined) {
    paginationParams.sort = "-id";
  }
};

export const sortDateRequest = (fieldsToSearch: any) => {
  if (fieldsToSearch?.date_request) {
    fieldsToSearch.date_request = FormatDate(
      fieldsToSearch.date_request,
      "YYYY-MM-DD"
    );
  }
  if (fieldsToSearch?.date_draw) {
    fieldsToSearch.date_draw = FormatDate(
      fieldsToSearch.date_draw,
      "YYYY-MM-DD"
    );
  }
  if (fieldsToSearch?.planning_date) {
    fieldsToSearch.planning_date = FormatDate(
      fieldsToSearch.planning_date,
      "YYYY-MM-DD"
    );
  }
  if (fieldsToSearch?.date_pickup) {
    fieldsToSearch.date_pickup = FormatDate(
      fieldsToSearch.date_pickup,
      "YYYY-MM-DD"
    );
  }
  if (fieldsToSearch?.scheduled_date) {
    fieldsToSearch.scheduled_date = FormatDate(
      fieldsToSearch.scheduled_date,
      "YYYY-MM-DD"
    );
  }
  if (fieldsToSearch?.prehosp_details) {
    fieldsToSearch.prehosp_details = FormatDate(
      fieldsToSearch.prehosp_details,
      "YYYY-MM-DD"
    );
  }
};
